import React from 'react';
import {observer} from 'mobx-react';
import {QuickTip, FormLayout, DatePicker, ObjectSelect2, TextArea, CheckboxWithLabel, FormError} from 'components';
import CustomHours from './CustomHours';
import DelegateAssignments from './DelegateAssignments';
import {FormattedMessage} from 'react-intl';
import {calendarDate, dateFormatter} from 'shared/tools';

const ExceededHoursList = observer(({exceededHours}) => {
  return (
    <ul className='pl2'>
      {exceededHours.map(day => {
        return <li key={day.date}>
          {calendarDate(day.date)}
        </li>;
      })}
    </ul>
  );
});

const Conflicts = observer(({uiState}) => {
  const {exceededHours} = uiState;

  if (exceededHours.length === 0) {
    return null;
  }
  return (
    <QuickTip
      trait='caution'
      header={<FormattedMessage id='employees.profile.time_off.request.CONFLICTING_HEADER'/>}
      paragraphs={[
        <FormattedMessage id='employees.profile.time_off.request.CONFLICTING_MESSAGE'/>,
        <ExceededHoursList exceededHours={exceededHours}/>
      ]}
    />
  );
});

const OnProbation = observer(({uiState}) => {
  const {employee, waitingPeriodFinalDay} = uiState;

  return (
    <QuickTip
      trait='caution'
      header={<FormattedMessage id='employees.profile.time_off.request.ON_PROBATION_HEADER'/>}
      paragraphs={[
        <FormattedMessage
          id='employees.profile.time_off.request.ON_PROBATION_MESSAGE'
          values={{name: employee.name, finalDay: dateFormatter(waitingPeriodFinalDay)}}
        />
      ]}
    />
  );
});

const RequestForm = observer(({uiState}) => {
  const {request, errors} = uiState;

  return (
    <FormLayout>
      {uiState.showProbationWarning && <OnProbation uiState={uiState}/>}
      <ObjectSelect2
        items={uiState.sortedTypes}
        value={request.timeOffType}
        onChange={timeOffType => uiState.changeTimeOffType(timeOffType)}
        label='employees.profile.time_off.request.Time Off Type'
      />
      <FormLayout.Group>
        <DatePicker
          label='employees.profile.time_off.request.Start Date'
          value={request.startDate}
          onChange={startDate => request.merge({startDate})}
          errorMessage={errors.startDate}
        />
        <DatePicker
          label='employees.profile.time_off.request.End Date'
          value={request.endDate}
          options={request.endDateDatePickerOptions}
          onChange={endDate => request.merge({endDate})}
          errorMessage={errors.endDate}
        />
      </FormLayout.Group>
      <CheckboxWithLabel
        label='employees.profile.time_off.request.Specify Custom Hours'
        onChange={() => uiState.toggleSpecifyCustomHours()}
        checked={uiState.specifyCustomHours}
      />
      <CustomHours uiState={uiState}/>
      <DelegateAssignments uiState={uiState}/>
      <Conflicts uiState={uiState}/>
      <TextArea
        label='employees.profile.time_off.request.Notes'
        value={request.notes}
        onChange={e => request.merge({notes: e.target.value})}
        placeholder='employees.profile.time_off.request.Enter request notes here'
        minRows={3}
      />
      <FormError message={errors.base}/>
    </FormLayout>
  );
});

export default RequestForm;
